import { Component, AfterViewInit } from '@angular/core'
import {ControlWidget} from 'ngx-schema-form'

@Component({
  selector: 'custom-checkbox',
  template: `
  <div class="course-poll-block">
  <div class="field-title">
	  {{ schema.title? schema.title : 'Заголовок' }}
  </div>
  <div *ngIf="schema.description" class="field-description">
	  {{ schema.description }}
  </div>
  <mat-checkbox *ngFor="let option of schema.items.oneOf; let i = index"
  [attr.name]="name"
  value="{{option.enum}}"
  (change)="onCheck($event)">
	  {{option.description? option.description : 'Вариант ' + i }}
  </mat-checkbox>
</div>
  `
})
export class CheckboxWidget extends ControlWidget implements AfterViewInit{
    checked: any = {};

	ngAfterViewInit() {
		const control = this.control;
		this.formProperty.valueChanges.subscribe((newValue) => {
            newValue.sort();
			if (control.value !== newValue) {
				control.setValue(newValue, { emitEvent: false });
				if (newValue && Array.isArray(newValue)) {
					newValue.map(v => this.checked[v] = true);
				}
			}
		});
		this.formProperty.errorsChanges.subscribe((errors) => {
			control.setErrors(errors, { emitEvent: true });
		});
		control.valueChanges.subscribe((newValue) => {
			this.formProperty.setValue(newValue, false);
		});
    }
    onCheck(el) {
		if (el.checked) {
			this.checked[el.value] = true;
		} else {
			delete this.checked[el.value];
		}
		this.formProperty.setValue(Object.keys(this.checked), false);
	}
}